import React from "react";
import ServicePageTemplate from "../../components/ServicePageTemplate";
import { Vote } from "lucide-react";

const ElectionFlying = () => {
  const serviceData = {
    serviceName: "Election Flying",
    heroImage: require("../../assets/Airbus-H160-election_flying.jpg"),
    heroTagline: "Campaign Aviation Support",
    heroDescription:
      "Maximize your campaign reach with our specialized election helicopter services. Cover more ground, meet more voters, and dominate the campaign trail.",
    overviewTitle: "Election Campaign Helicopter Services",
    overviewText: `HighKraft Aviation provides specialized helicopter services for political campaigns and election activities. When you're racing against time to reach voters across multiple constituencies, our election flying service gives you the competitive edge.

During election seasons, every minute counts. Our helicopter charter services enable political leaders and candidates to attend multiple rallies, meetings, and events across vast distances in a single day. Beat the traffic, bypass road closures, and maintain your campaign momentum.

We understand the unique requirements of election campaigns – flexibility, reliability, and the ability to respond to rapidly changing schedules. Our experienced team works closely with campaign managers to plan efficient routes and ensure seamless logistics.`,
    useCases: [
      {
        title: "Multi-Rally Coverage",
        description:
          "Attend multiple rallies across different constituencies in a single day.",
      },
      {
        title: "Quick Response Tours",
        description:
          "Rapidly respond to emerging situations or opportunities across your campaign region.",
      },
      {
        title: "VIP Politician Transport",
        description:
          "Safe and secure transportation for high-profile political figures.",
      },
      {
        title: "Remote Area Access",
        description:
          "Reach voters in remote areas not easily accessible by road.",
      },
      {
        title: "Campaign Team Movement",
        description:
          "Transport campaign teams and staff efficiently between locations.",
      },
      {
        title: "Media Coverage Support",
        description:
          "Coordinated flights for media coverage and press accompaniment.",
      },
    ],
    safetyFeatures: [
      {
        title: "DGCA Compliant Operations",
        description:
          "All election flights comply with DGCA regulations and Election Commission guidelines.",
      },
      {
        title: "Experienced Campaign Pilots",
        description:
          "Pilots experienced in election flying with knowledge of crowd management.",
      },
      {
        title: "Security Coordination",
        description:
          "Close coordination with security agencies for VIP protection.",
      },
      {
        title: "Landing Zone Assessment",
        description:
          "Pre-flight assessment of all landing zones for safety compliance.",
      },
      {
        title: "Real-time Communication",
        description:
          "Constant communication with ground teams for coordinated operations.",
      },
      {
        title: "Backup Aircraft Availability",
        description:
          "Backup helicopters available to ensure campaign continuity.",
      },
    ],
    galleryImages: [
      "https://images.pexels.com/photos/104757/pexels-photo-104757.jpeg",
      "https://images.pexels.com/photos/1686990/pexels-photo-1686990.jpeg",
      "https://images.unsplash.com/photo-1557818673-effec50525e1",
    ],
    faqs: [
      {
        question: "What approvals are needed for election flying?",
        answer:
          "We handle all necessary approvals including DGCA permissions, district administration clearances, and coordination with the Election Commission as required.",
      },
      {
        question: "Can you accommodate last-minute schedule changes?",
        answer:
          "Yes, we understand election campaigns are dynamic. Our operations team is equipped to handle schedule changes with minimal notice.",
      },
      {
        question: "How many constituencies can we cover in a day?",
        answer:
          "Depending on distances and event durations, candidates can typically cover 4-8 constituencies in a single day with helicopter transport.",
      },
      {
        question: "Do you provide landing arrangements at rally venues?",
        answer:
          "We coordinate with local authorities to secure safe landing zones at or near rally venues. Our team assesses each location in advance.",
      },
      {
        question: "What are the costs involved?",
        answer:
          "Election charter costs depend on flight hours, number of days, and specific requirements. Contact us for a customized quote based on your campaign schedule.",
      },
    ],
    icon: Vote,
  };

  return <ServicePageTemplate {...serviceData} />;
};

export default ElectionFlying;
